import dynamic from 'next/dynamic'
import React, {ReactElement} from 'react'

import Footer from '@miro-site/components_footer'
import {LandingPageProps, Layout} from '../lib/contentful/types'
import Components from '../utils/components'
import {useContentfulData} from '@miro-site/core'

interface FooterRendererProps {
  sections: Layout
  styleSystem?: LandingPageProps['styleSystem']
}

const FooterRenderer = ({sections, styleSystem}: FooterRendererProps): ReactElement => {
  const pageProps = useContentfulData() as LandingPageProps
  const {footer} = pageProps
  /**
   * The "normal" footer can be loaded in stitches or styled-components.
   */
  if (footer) {
    if (styleSystem !== 'twig') {
      /**
       * Dynamically loads and return the stitches footer for specific pages
       */
      const StandardFooter = dynamic(() => import('@miro-site/features-standard-footer'))
      return <StandardFooter {...footer} />
    }
    /**
     * Returns the styled-components footer for all other pages
     */
    return <Footer {...footer} />
  }
  /**
   * If the `footer` prop doesn't exists, defaults to using the acquisition footer
   */
  return <Components.AcquisitionFooter />
}

export default FooterRenderer
